// extracted by mini-css-extract-plugin
module.exports = {"metricTitle":"Metric_metricTitle__1VFBy","metricValue":"Metric_metricValue__2nSAJ"};